import FilesIcons from '@common-components/files-icons/filesIcons'
import { getBoardNameById } from '@common-reducers/BoardsSelectors';
import { tasksSelectors } from "@common-reducers/DBServiceThunks";
import { useAppSelector } from '@common-reducers/hooks/store.hook';
import classes from "./media_manager_header.module.scss";

export interface Props {
    file: Record<string, any>;
    fileName?: string;
}

const MediaManagerHeader = ({ file, fileName }: Props) => {
    const taskId = useAppSelector((state) => state.MediaManagerReducer.taskId);
    const task = useAppSelector((state) => tasksSelectors.selectById(state, taskId));
    // Resolve the board from the file's task (task.boardId), NOT the currently
    // selected board — the media manager can be opened for a task that lives on a
    // different board than the one on screen.
    const boardName = useAppSelector((state) =>
        task?.boardId ? getBoardNameById(state, task.boardId) : ""
    );

    return (
        <div className={classes.fileDetails}>
            <div className={classes.iconWrap}>
                <FilesIcons file={file} />
            </div>
            <div className={classes.fileNameAndPath}>
                <span className={classes.fileName} title={fileName}>{fileName}</span>
                {task ? (
                    <nav className={classes.breadcrumb} aria-label="file location">
                        {boardName && <span className={classes.crumb}>{boardName}</span>}
                        {boardName && <span className={classes.separator}>/</span>}
                        <span className={classes.crumb}>{task.text}</span>
                        <span className={classes.separator}>/</span>
                        <span className={classes.crumb}>Files</span>
                        {fileName && <span className={classes.separator}>/</span>}
                        {fileName && <span className={classes.crumbActive} title={fileName}>{fileName}</span>}
                    </nav>
                ) : (
                    <span className={classes.breadcrumb}>All Files</span>
                )}
            </div>
        </div>
    )
}

export default MediaManagerHeader
